var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":("tel:" + _vm.tel)}},[_c('div',{staticClass:"phone"},[_c('phone-image',{staticClass:"phone__icon"}),_vm._v("\n    "+_vm._s(_vm.tel)+"\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }